module.exports = __webpack_public_path__ + "img/qr_code 18px OLD.14fa2ab2.svg";